// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1Ytmj","checkboxCol":"Table_checkboxCol__SG6m2","emailCol":"Table_emailCol__npO8l","actionCol":"Table_actionCol__2DsvX"};